<template>
  <div class="activestate-page">
    <h1>森林人 STI SPORT全国品鉴会活动说明</h1>
    <div class="content">
      <p style="text-indent: 28px;">在活动期间购买森林人 STI SPORT，并在本活动页面上传对应的订车信息与购车发票，可参与“森林人 STI SPORT全国品鉴会”活动，有机会获得STI SPORT 555限量徽章和STI礼品套装以及日本SUPER GT观赛的资格</p>
      <p style="font-weight:600;">活动规则</p>
      <p style="text-indent: 28px;">1.活动期间在斯巴鲁经销商订车，且扫描二维码进入小程序完成报名活动，上传订车合同和身份证信息，通过审核后选择号码领取STI SPORT 555限量徽章（按上传顺序审核，礼品数量有限先到先得发完为止）</p>
      <p style="text-indent: 28px;">2.通过小程序上传购车发票进行审核，审核通过后可选择领取价值2000元的STI礼品套装（图片仅供示意，可能因库存做出调整，按上传顺序审核，礼品数量有限先到先得发完为止）</p>
      <p style="text-indent: 28px;">3.针对9月23日起至10月31日盲订车辆且在12月31日前开具发票并上传至小程序的车主，将通过斯巴鲁官方直播账号并在公正人员见证下抽取10位幸运用户参加日本SUPER GT观赛</p>
      <p style="font-size:10px;text-align:right;">本次活动最终解释权为斯巴鲁汽车（中国）有限公司所有</p>
      <p></p>
      <p></p>
      <p></p>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        name: '富士范儿'
      }
    },
    created () {
      this.$store.commit('param/show', false)
    // his.name = '凌志范儿'
    this.$appService.isShowReturn({state: true})
  //   let source = this.$store.state.param.source
  //   if(source == 3) {
  //     this.name = '汽车时间'
  //     this.$appService.isShowReturn({state: true})
  // } else if(source == 6) {
  //     this.name = '凌志范儿'
  //     this.$appService.isShowReturn({state: true})
  // }else if(source == 8) {
  //     this.name = '凌志范儿'
  //     this.$appService.isShowReturn({state: true})
  // }
},
methods: {

}
};
</script>

<style lang="scss">
  .activestate-page {
    padding: 10px;
    background-color: #ffffff;

    h1 {
      font-size: 20px;
      margin: 5px 0 10px 0;
      text-align: center;
    }
    .content {

      h5 {
        font-size: 16px;
        margin: 10px 0 0 0;
      }
      p {
        margin: 10px 0 0 0;
        font-size: 14px;
      }
    }
  }
</style>
